import { render, staticRenderFns } from "./BriqMultiselectWarningLabel.vue?vue&type=template&id=4951c684&scoped=true&lang=pug&functional=true&"
var script = {}
import style0 from "./BriqMultiselectWarningLabel.vue?vue&type=style&index=0&id=4951c684&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4951c684",
  null
  
)

export default component.exports